<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<!--====================================================
                       HOME-P
======================================================-->
<div id="home-p" class="text-center">  
  <a target="_blank" href="https://www.reencauchadoraremax.com/">
    <img src="assets/img/REMAXBanner.jpg" class="img-fluid" alt="..." />
  </a>  
</div>
<div class="container remax">
  <h3>CONTÁCTeNOS</h3>
  <ul class="contacto">
    <li class="fa fa-tablet fa-3x">
      <b>Teléfonos: 418 6300 --- PBX: 545 5452</b>
      <span>Llámanos</span>
    </li>
    <li class="fa fa-envelope-o fa-3x">
      <a href="mailto:vetas@reencauchadoraremax.com" class="">vetas@reencauchadoraremax.com</a>
      <span>Escribanos para resolver cualquier inquietud</span>
    </li>
    <li class="fa fa-clock-o fa-3x">
      <b>Horarios de Atención</b>
      <span>Lunes a Viernes: 7:30 a.m. - 5:30 p.m. y Sábados 8:00 a.m. 1:00 p.m.</span>
    </li>
  </ul>
</div>
<!--====================================================
                  BUSINESS-GROWTH-P1
======================================================-->
<section id="business-growth-p1" class="business-growth-p1 bg-gray">
  <div class="container">
    <div class="row title-bar">
      <div class="col-md-12">
        <h1 class="wow fadeInUp">REMAX</h1>
        <div class="heading-border"></div>
        <p class="wow fadeInUp" data-wow-delay="0.4s">
          Somos una empresa reencauchadora de llantas con años de experiencia,
          que presta servicios de renovado, comercialización de llantas premium
          y administración de llantas enfocada en la atención de clientes para
          garantizar ahorro en sus operaciones..
        </p>
      </div>
    </div>
    <div
      class="row wow animated fadeInUp"
      data-wow-duration="1s"
      data-wow-delay="0.5s"
    >
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon">
            <i class="fa fa-life-ring fa-3x"></i>
          </div>
          <div class="service-item-title">
            <h3>Llantas Nuevas</h3>
          </div>
          <div class="service-item-desc">
            <p>Comercialización de llantas</p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon">
            <i class="fa fa-envira fa-3x"></i>
          </div>
          <div class="service-item-title">
            <h3>Disposición Final</h3>
          </div>
          <div class="service-item-desc">
            <p>Disposición final ambientalmente segura.</p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon">
            <i class="fa fa-wrench fa-3x"></i>
          </div>
          <div class="service-item-title">
            <h3>Reencauche</h3>
          </div>
          <div class="service-item-desc">
            <p>Servicio de reencache en banda vipal</p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
                FINANCIAL-P1
======================================================-->
<section id="financial-p1" class="bg-parallax remax-p3-bg">
  <div class="overlay-financial-p1"></div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 financial-p1-pos">
        <div class="financial-p1-cont">
          <!--<a href="#"> <b>Richtech Technology</b></a> -->
          <h3>BANDAS DIRECCIONAL</h3>
          <p>
            El patrón direccional (también conocido como unidireccional) ha sido
            diseñado para rodar en una dirección solamente. Incorpora ranuras
            laterales en ambos lados de la línea central del neumático y apuntan
            a la misma dirección resultando en una forma tipo "V" Estas ranuras
            mejoran considerablemente la resistencia al deslizamiento en agua
            (hydroplaning) a velocidades elevadas al bombear agua con mayor
            eficacia a través de la banda de rodamiento. Los neumáticos
            direccionales deben ser utilizados solamente en un lado del vehículo
            y deben ser rotados del eje frontal al trasero y viceversa. Para
            utilizarlos en el otro lado del vehículo deben ser desmontados y
            remontados en los rines. Si el tamaño de los neumáticos en el frente
            son diferentes al de los traseros, su uso necesita ubicaciones
            específicas y no pueden ser rotados, a menos que se remonten en los
            rines.
          </p>
          <!--<button class="btn btn-general btn-white" role="button">
            Contact Us
          </button> -->
        </div>
      </div>
      <div class="col-md-6 financial-p1-emp-img"></div>
    </div>
  </div>
</section>
<section id="financial-p1" class="bg-parallax remax-p2-bg">
  <div class="overlay-financial-p1"></div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 financial-p1-emp-img"></div>
      <div class="col-md-6 financial-p1-pos financial-p1-emp-desc-d">
        <div class="financial-p1-cont">
          <h3>Reencauche de llantas, ¿Sabe en qué consiste?</h3>
          <p>
            El cuidado de las llantas de un vehículo es esencial para su buen
            funcionamiento. El reencauche consiste en retirar la banda de
            rodamiento de las llantas gastadas para colocarles una nueva que les
            permita seguir siendo útiles. Este proceso debe cumplir con los
            mismos niveles de calidad que una llanta nueva e incluso mejores que
            algunas llantas.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-contacto></app-contacto>
<app-footer></app-footer>